

import Show from "./components/show"
import Festival from "./components/festival"
import ShowPreview from "./components/show-preview"
import ShowSimple from "./components/show-simple"
import FestivalPreview from "./components/festival-preview"
import SpecialScreeningPreview from "./components/show-special-screening"

import mountainStagePoster from "./images/shows/mountain_stage.jpg";

import londonFlagImage from "./images/london_flag.png";

let shows = [
    {
      title: "Mean Girls",
      subtitle: "You Can Sit With Us.",
      date: new Date(2024, 10, 13),
      dateFormatted: "Wednesday November 13th 2024",
      dateFormattedShort: "Nov 13th",
      timeFormatted: "7:30 pm",
      location: "Joan C. Edwards Playhouse",
      tickets: "https://www.ticketmaster.com/event/160060F009E54127",
      website: "",
      trailer: "https://www.youtube.com/watch?v=mRQL--5C-EA",
      description: `Featuring a book by Tina Fey, mean girls the broadway musical tells the story of a naïve newbie who falls prey to a trio of lionized frenemies. Entertainment weekly calls it "A marvel: dazzling and hilarious!" and USA today says, "We'll let you in on a little secret, because we're such good friends."`,
      content: `
      `,
      backgroundColor: "#1C6EFF",
      previewTemplate: ShowPreview,
      template: Show,
      sponsors: [
        {name:"Dutch Miller Kia", level:1},
        {name:"CJ Hughes", level:1},
        {name:"NRP", level:1},
        {name:"Dinsmore", level:2},
        {name:"Steptoe & Johnson", level:2},
        {name:"Neighborgall Construction", level:3},
        {name:"Air Systems, Inc.", level:3},
        {name:"Marshall Orthopaedics", level:3},
        {name:"Dr.Mark Studeny & Dr. Melissa Lester", level:3, text:true},
        {name:"Reger Funeral Home", level:3},
        {name:"La Famiglia", level:4},
      ]
    },
    {
      title: "Dear Evan Hansen",
      subtitle: "",
      date: new Date(2025, 3, 14),
      dateFormatted: "Monday April 14th 2025",
      dateFormattedShort: "Apr 14th",
      timeFormatted: "7:30 pm",
      location: "Joan C. Edwards Playhouse",
      tickets: "https://www.ticketmaster.com/event/160060F009F54136",
      website: "",
      trailer: "https://www.youtube.com/watch?v=ra0PPsRFiaE",
      description: `Declared "One of the most remarkable shows in musical theater history" by the washington post, Dear Evan Hansen is the first musical to take a groundbreaking look from the point of view of both the parents and young people at our complex, interconnected, and social-media-filled lives.`,
      content: `
      `,
      backgroundColor: "#1C6EFF",
      previewTemplate: ShowPreview,
      template: Show,
      sponsors: [
        {name:"Mike & Tammy Farrell", level:2, text:true},
        {name:"The Touma Foundation", level:2},
        {name:"Dr. Christopher & Mrs. Tammy Hugh", level:3, text:true},
        {name:"Ginos", level: 4},
      ]
    },
    {
      title: "Ricky Skaggs & Kentucky Thunder",
      subtitle: "Christmas",
      date: new Date(2024, 11, 12),
      dateFormatted: "Thursday December 12th 2024",
      dateFormattedShort: "Dec 12th",
      timeFormatted: "7:30 pm",
      location: "Joan C. Edwards Playhouse",
      tickets: "https://www.ticketmaster.com/event/160060F009ED4130",
      website: "",
      trailer: "https://www.youtube.com/watch?v=X-I-1sb3sJE",
      description: `You know "Christmas Time's A Coming" when 15 TIME GRAMMY WINNER and COUNTRY MUSIC HALL OF FAME MEMBER RICKY SKAGGS and his ace backing band KENTUCKY THUNDER play all your favorite Christmas songs in their refreshing style. This heartwarming show features a reason to listen to the season of songs both old and new as Skaggs and his band perform their own perfect blend of tight harmony. Come celebrate this special time of year with friends and family, while listening to first class vocalists and musicians, singing and playing their finest for Christmas time.`,
      content: `
      `,
      backgroundColor: "#1C6EFF",
      previewTemplate: ShowPreview,
      template: Show,
      sponsors: [
        {name:"Marshall Health Network", level:1},
        {name:"WV Lottery", level:2},
        {name:"The Chirico Family", level:3, text:true},
        {name:"Wilmink Smith Cline", level:3},
        {name:"David & Kim Robinson", level:3, text:true},
        {name:"Dr David & Mrs. Sharon Denning", level:4, text:true},
        {name:"Huntington Federal", level:4},
        {name:"Radiology Inc.", level:4},
        {name:"Ransbottom Law Office", level:4},
        {name:"Dr.Mark Studeny & Dr. Melissa Lester", level:4, text:true},
        {name:"Marsha Slater State Farm Insurance", level:4, text:true},
        {name:"21 @ Frederick", level:5},
      ]
    },
    {
      title: "Mountain Stage with Kathy Mattea",
      subtitle: "",
      date: new Date(2024, 9, 20),
      dateFormatted: "Sunday October 20th 2024",
      dateFormattedShort: "Oct 20th",
      timeFormatted: "7:00 pm",
      location: "Joan C. Edwards Playhouse",
      tickets: "https://www.ticketmaster.com/event/160060F009DD410D",
      website: "https://mountainstage.org/",
      trailer: "",
      description: `Be a part of the live audience as Mountain Stage records a fresh episode for NPR Music with Grammy-winning country and bluegrass music superstar Kathy Mattea as host! An assorted medley of musical styles will be featured, including Mississippi inspired north country blues from JD Simo and Luther Dickinson, Australian singer-songwriter Paul Kelly's blend of heartfelt lyrics and timeless folk-rock melodies, expert storytelling from John Craigie, fresh and innovative bluegrass from the Kyle Tuttle Band, and eclectic Appalachian roots sounds from Kentucky band Wayne Graham.`,
      content: `
        <div style="clear:both;">
        <h3>Mountain Stage Artists</h3>
        <div>
          <div style="background-color: #333; padding: 10px; border-radius: 5px; margin-bottom: 10px;">
            <strong>JD Simo & Luther Dickinson</strong><br />
            <div><a href="https://www.youtube.com/watch?v=8GKfRYihujA" target="_blank" style="color:white;">View Band Video</a></div>
          </div>
          <div style="background-color: #333; padding: 10px; border-radius: 5px; margin-bottom: 10px;">
            <strong>Kyle Tuttle Band</strong><br />
            <div><a href="https://www.youtube.com/watch?v=Phg_8ADT3YY" target="_blank" style="color:white;">View Band Video</a></div>
          </div>
          <div style="background-color: #333; padding: 10px; border-radius: 5px; margin-bottom: 10px;">
            <strong>John Craigie</strong><br />
            <div><a href="https://www.youtube.com/watch?v=7wldRoZenss" target="_blank" style="color:white;">View Band Video</a></div>
          </div>
          <div style="background-color: #333; padding: 10px; border-radius: 5px; margin-bottom: 10px;">
            <strong>Wayne Graham</strong><br />
            <div><a href="https://www.youtube.com/watch?v=EPDIsMemDWc" target="_blank" style="color:white;">View Band Video</a></div>
          </div>
          <div style="background-color: #333; padding: 10px; border-radius: 5px; margin-bottom: 10px;">
            <strong>Paul Kelly</strong><br />
            <div><a href="https://www.youtube.com/watch?v=kipFPmGjjFQ" target="_blank" style="color:white;">View Band Video</a></div>
          </div>
        </div>
        </div>
      `,
      poster: mountainStagePoster,
      backgroundColor: "#1C6EFF",
      previewTemplate: ShowPreview,
      template: Show,
      sponsors: [
        {name:"Farrell & Farrell", level:3},
        {name:"ZMM Architects", level:3},
        {name:"City National Bank", level:3},
        {name:"Marshall Health", level:3},
        {name:"Larry & Cheryl Tweel", level:4, text:true},
        {name:"Roccos", level:5},
      ]
    },
    {
      title: "A Conversation with Henry Louis Gates, JR",
      subtitle: "",
      date: new Date(2024, 10, 15),
      dateFormatted: "Friday November 15th 2024",
      dateFormattedShort: "Nov 15th",
      timeFormatted: "7:30 pm",
      location: "Joan C. Edwards Playhouse",
      mastersAtMarshall: true,
      mastersAtMarshallTickets: "https://www.ticketmaster.com/event/160060F012D04401",
      tickets: " https://www.ticketmaster.com/henry-louis-gates-jr-huntington-west-virginia-11-15-2024/event/160060F1784412CF",
      website: "",
      trailer: "https://www.youtube.com/watch?v=fUs7Kehf7bs",
      description: `A native of Piedmont, West Virginia, Henry Louis Gates, Jr. earned his B.A. in History, summa cum laude, from Yale University in 1973, and his M.A. and Ph.D. in English Literature from Clare College at Cambridge in 1979, where he is also an Honorary Fellow. A former chair of the Pulitzer Prize board, he is a member of the American Academy of Arts and Letters and serves on a wide array of boards, including the New York Public Library, the NAACP Legal Defense Fund, the Aspen Institute, the Whitney Museum of American Art, Library of America, and The Studio Museum of Harlem.`,
      content: `
        In 2011, his portrait, by Yuqi Wang, was hung in the National Portrait Gallery in Washington, D.C. He is a member of the Phi Beta Kappa honor society. Henry Louis Gates, Jr. is the Alphonse Fletcher University Professor and Director of the Hutchins Center for African & African American Research at Harvard University. Emmy and Peabody Award-winning filmmaker, literary scholar, journalist, cultural critic, and institution builder, Professor Gates's most recent books are The Black Box: Writing the Race, Stony the Road: Reconstruction, White Supremacy, and the Rise of Jim Crow and The Black Church: This Is Our Story, This Is Our Song. He has also produced and hosted an array of documentary films. The Black Church (PBS) and Frederick Douglass: In Five Speeches (HBO), which he executive produced, each received Emmy nominations. His latest history series for PBS are Gospel and Making Black America: Through the Grapevine. Finding Your Roots, Gates's groundbreaking genealogy and genetics series, is in its tenth season on PBS.      
      `,
      posterInfo: "Conversation moderated by Marshall President Brad D. Smith.",
      backgroundColor: "#1C6EFF",
      previewTemplate: ShowPreview,
      template: Show,
      sponsors: [
        {name:"The Huntington Foundation, Inc.", level:1, text:true},
        {name:"City of Huntington", level:1},
        {name:"Nelson Mullins", level:1},
        {name:"Anonymous", level:2, text:true},
        {name:"Society of Black Scholars at Marshall University", level:3, text:true},
        {name:"President Brad D. Smith Home", level:4, text:true},
      ]
    },
    {
      title: "A Conversation with Javier Zamora",
      subtitle: "",
      date: new Date(2025, 2, 6),
      dateFormatted: "Thursday March 6th, 2025",
      dateFormattedShort: "Mar 6th",
      timeFormatted: "7:30 pm",
      location: "Joan C. Edwards Playhouse",
      mastersAtMarshall: true,
      mastersAtMarshallTickets: "https://www.ticketmaster.com/event/160060F012D04401",
      tickets: "https://www.ticketmaster.com/event/160060F1789312E3",
      website: "",
      trailer: "https://www.youtube.com/watch?v=_2iEeq6LThE",
      description: `In his debut memoir, the New York Times Bestseller, Solito, Salvadoran poet Javier Zamora retells his nine-week odyssey across Guatemala, Mexico, and the Sonoran Desert before reuniting with his parents in California.`,
      content: `
        Accompanied only by strangers and a hired “coyote,” Zamora left his beloved aunt and grandparents to reunite with his mother and father in the United States. The three-thousand-mile journey, only expected to last two weeks until he was abandoned in Oaxaca, stretched into two life-altering months spent among strangers turned guardians as he traveled from El Salvador to Guatemala and then Mexico before arriving in the United States. Narrated by his nine-year-old self, Zamora's memoir, Solito, provides an intimate account of his near-impossible journey and the unexpected moments of kindness, love, and joy scattered across perilous boat trips, desert treks, arrests, and betrayals.    
        <p>
        “The magic of this book lies not only in the beguiling voice of young Javier, or the harrowing journey and immense bravery of the migrants, or in the built-in hero's journey of this narrative. It's hard to reconcile the fact that this book hasn't always been with us. How can something so essential and fundamental to the American story not already be part of our canon?” —San Francisco Chronicle    
      `,
      posterInfo: "Conversation Moderated by Dr. Avi Mukherjee",
      backgroundColor: "#1C6EFF",
      previewTemplate: ShowPreview,
      template: Show,
      sponsors: [
        {name:"The Huntington Foundation, Inc.", level:1, text:true},
        {name:"City of Huntington", level:1},
        {name:"Nelson Mullins", level:1},
        {name:"Drinko Academy", level:2},
        {name:"Anonymous", level:2, text:true},
        {name:"Huntington's Kitchen", level:4},
      ]
    },

    {
      festival: true,
      title: "International Film Festival",
      subtitle: "",
      date: new Date(2024, 9, 26),
      dateFormatted: "Saturday October 26th, 2024",
      dateFormattedShort: "Oct 26th",
      location: "Joan C. Edwards Playhouse",
      ticketInfo: "* Film tickets may be purchased at the door prior to each film",
      website: "",
      trailer: "",
      shows: [
        {
          name: "robot_dreams", 
          title:"Robot Dreams", 
          country: "Spain", 
          language: "None", 
          length: "1 Hour 42 Minutes",
          schedule: ["12:30 PM"],
          trailer: "https://www.youtube.com/watch?v=DD4WBGptMSw"
        },
        {
          name: "anatomy_of_a_fall", 
          title:"Anatomy of a Fall", 
          country: "France", 
          language: "English & French with English Subtitles", 
          length: "2 Hours 30 Minutes",
          schedule: ["2:30 PM"],
          trailer: "https://www.youtube.com/watch?v=fTrsp5BMloA"
        },        
        {
          name: "past_lives", 
          title:"Past Lives", 
          country: "US/Korea", 
          language: "English & Korean with English Subtitles", 
          length: "1 Hour 46 Minutes",
          schedule: ["5:30 PM"],
          trailer: "https://www.youtube.com/watch?v=WJTnve_kdu0"
        },
        {
          name: "perfect_days", 
          title:"Perfect Days", 
          country: "Japan", 
          language: "Japanese with English Subtitles", 
          length: "2 Hours 3 Minutes",
          schedule: ["7:30 PM"],
          trailer: "https://www.youtube.com/watch?v=QzZBbX5A1FA"
        },
      ],
      description: "",      
      content: `
      `,
      backgroundColor: "#1C6EFF",
      previewTemplate: FestivalPreview,
      template: Festival,
      sponsors: [
        {name:"Cabell Huntington CVB", level:2},
      ]
    },

    {
      title: "Banff Mountain Film Festival",
      subtitle: "The World's Best Mountain Films",
      date: new Date(2025, 3, 3),
      dateFormatted: "Thursday April 3rd 2025",
      dateFormattedShort: "Apr 3rd",
      timeFormatted: "7:00 pm",
      location: "Joan C. Edwards Playhouse",
      tickets: "https://www.ticketmaster.com/event/160060F19BE81EFF",
      website: "https://www.banffcentre.ca/banffmountainfestival/tour/us",
      trailer: "https://www.youtube.com/watch?v=9YhV6I8conw",
      description: "The Banff Mountain Film Festival is the most prestigious mountain festival in the world. Featuring the world's best mountain sport, culture and environmental films, you can experience the thrill and challenges of the mountain environments that inspire us all. These films explore the mountain world, highlighting new landscapes and remote cultures, and exposes audiences to exciting adventures and adrenaline packed sports. Since 1986, right after the festival, held every fall in Banff, Alberta, the Banff Mountain Film Festival World Tour starts to travel around the globe with stops in 450 communities and 40 countries.",
      content2: `
        <h3>Festival Films</h3>
        <div>
          <div style="background-color: #333; padding: 10px; border-radius: 5px; margin-bottom: 10px;">
            <strong>NO WAY</strong><br />
            <p style="margin: 0px; font-size: 90%;">Jean-Baptiste Chandelier takes his unique low-flying, ground-skimming art combining paragliding and filmmaking to a whole new level.</p>
            <a href="https://www.dropbox.com/sh/r98ffiufq2b5c5i/AADyXBwCqLY9ROw0N2V813_1a?dl=0&preview=No+Way+Fail+FPV+V5.mp4" target="_blank" style="display: block; color: #0773B9; margin-top: 5px;">Video Trailer</a>
          </div>
          <div style="background-color: #333; padding: 10px; border-radius: 5px; margin-bottom: 10px;">
            <strong>SCHOOL OF FISH</strong><br />
            <p style="margin: 0px; font-size: 90%;">Indigenous people and salmon have been intertwined for thousands of years in Bristol Bay, Alaska. For the last century, corporations have sought to extract the wealth of this rich region and now Pebble Mine threatens to pollute its pristine headwaters. Can the next generation step up to defend the most prolific salmon run left on earth?</p>
            <a href="https://www.dropbox.com/sh/r98ffiufq2b5c5i/AADyXBwCqLY9ROw0N2V813_1a?dl=0&preview=SchoolofFish_Trailer_60s_Horizontal2.mp4" target="_blank" style="display: block; color: #0773B9; margin-top: 5px;">Video Trailer</a>
          </div>
          <div style="background-color: #333; padding: 10px; border-radius: 5px; margin-bottom: 10px;">
            <strong>TO BE FRANK</strong><br />
            <p style="margin: 0px; font-size: 90%;">Frank Paine is a 73-year-old South Bay icon and humble local legend whose life orbits around a two-block stretch of beach. His unforgettable mustache is what most first notice, but his magnetic spirit and unwavering passion are what keeps the Hermosa Beach surf community connected and whole.</p>
            <a href="https://www.dropbox.com/sh/r98ffiufq2b5c5i/AADyXBwCqLY9ROw0N2V813_1a?dl=0&preview=TBF_TRAILER.mp4" target="_blank" style="display: block; color: #0773B9; margin-top: 5px;">Video Trailer</a>
          </div>
          <div style="background-color: #333; padding: 10px; border-radius: 5px; margin-bottom: 10px;">
            <strong>WELL WORN LIFE WITH DANI REYES-ACOSTA</strong><br />
            <p style="margin: 0px; font-size: 90%;">Meet Dani Reyes-Acosta: a mountain athlete, land cultivator, and storyteller whose path consistently seeks the limits of her possibility.</p>
            <a href="https://www.dropbox.com/sh/r98ffiufq2b5c5i/AADyXBwCqLY9ROw0N2V813_1a?dl=0&preview=WellWornLifeTRAILER.mp4" target="_blank" style="display: block; color: #0773B9; margin-top: 5px;">Video Trailer</a>
          </div>
          <div style="background-color: #333; padding: 10px; border-radius: 5px; margin-bottom: 10px;">
            <strong>THE ASCENSION SERIES: MORAG SKELTON</strong><br />
            <p style="margin: 0px; font-size: 90%;">Morag Skelton doesn't let anything stand in the way of her love of nature. As a deaf climber, she is constantly pushing the limits of what is possible on the mountainside.</p>
            <a href="https://www.dropbox.com/sh/r98ffiufq2b5c5i/AADyXBwCqLY9ROw0N2V813_1a?dl=0&preview=the_ascension_series__morag_skelton_-_promo_clip+(1080p).mp4" target="_blank" style="display: block; color: #0773B9; margin-top: 5px;">Video Trailer</a>
          </div>
          <div style="background-color: #333; padding: 10px; border-radius: 5px; margin-bottom: 10px;">
            <strong>CHRONOCEPTION</strong><br />
            <p style="margin: 0px; font-size: 90%;">Thomas Delfino, Léa Klaue and Aurélien Lardy, embark on an ambitious expedition in the mountains of Kyrgyzstan to ski the Kok-shaal-Too range. This skilled team, accompanied by renowned guides Hélias Millerioux and Jean-Yves Fredriksen, finds themselves propelled into a space where time seems to have suddenly come to a halt.</p>
            <a href="https://www.dropbox.com/sh/r98ffiufq2b5c5i/AADyXBwCqLY9ROw0N2V813_1a?dl=0&preview=CHRONOCEPTION+TRAILER.mp4" target="_blank" style="display: block; color: #0773B9; margin-top: 5px;">Video Trailer</a>
          </div>
          <div style="background-color: #333; padding: 10px; border-radius: 5px; margin-bottom: 10px;">
            <strong>GOING GREENLAND</strong><br />
            <p style="margin: 0px; font-size: 90%;">What happens when you combine a renewable energy sailboat with an artic ski expedition in Greenland for the first time ever? Athletes Rachael Burks and Jessica Baker put the idea to test, and endure a both harrowing and inspiring journey along Greenland's West coast fjords and towering mountains.</p>
            <a href="https://www.dropbox.com/sh/r98ffiufq2b5c5i/AADyXBwCqLY9ROw0N2V813_1a?dl=0&preview=GOING_GREENLAND_TRAILER_2023.mp4" target="_blank" style="display: block; color: #0773B9; margin-top: 5px;">Video Trailer</a>
          </div>
          <div style="background-color: #333; padding: 10px; border-radius: 5px; margin-bottom: 10px;">
            <strong>REEL ROCK: DNA</strong><br />
            <p style="margin: 0px; font-size: 90%;">French sport climber Seb Bouin has been quietly working his way through elite grades, culminating in his attempt to establish a long pitch through an overhanging cave in the Verdon Gorge of France - possibly the most difficult route in the world!</p>
            <a href="https://www.dropbox.com/sh/r98ffiufq2b5c5i/AADyXBwCqLY9ROw0N2V813_1a?dl=0&preview=Reel+Rock+-+DNA+-+Social+Media+Trailer.mp4" target="_blank" style="display: block; color: #0773B9; margin-top: 5px;">Video Trailer</a>
          </div>
        </div>
      `,
      backgroundColor: "#1C6EFF",
      previewTemplate: ShowPreview,
      template: Show,
      sponsors: [
        {name:"Cabell Huntington CVB", level:2},
        {name:"Community Trust Bank", level:2},
      ]
    },    
    
    {
      title: "Scandalous Stones",
      subtitle: "With Douglas Chirnside",
      subsubtitle: "A London Cabaret",
      date: new Date(2025, 1, 6),
      dateFormatted: "Thursday February 6th, 2025",
      dateFormattedShort: "Feb 6th",
      timeFormatted: "8:30 pm",
      logoImage: londonFlagImage,
      doorsOpen: "* General admission seating begins at 8:15 p.m",
      location: "Rocco's at the Green Room",
      ticketInfo: "For tickets call 304-696-6656",
      website: "",
      trailer: "",
      description: `Join us for an intimate evening with historian and award-winning BBC documentary filmmaker Douglas Chirnside as he crosses the pond to delve into the secrets & scandals of the priceless jewels amassed by the British Monarchy.  Douglas will share the fascinating history of the Queen's private jewels, tell us who wore what pieces, and reveal the historical significance of each treasure.`,
      description: `Direct from London, discover Scandalous Stones with Douglas Chirnside, at Rocco's At The Green Room (226 Main St. in Ceredo).  Enjoy a complimentary glass of wine as historian and award-winning BBC documentary filmmaker Douglas Chirnside guides you through the rich history of the priceless jewels amassed by the British Monarchy. Chirnside's one-hour discussions will be paired with a video showcase highlighting select pieces of the Royal Crown Jewels (some never seen before). Today these prized jewels often spark as much controversy as they do fascination.  Learn more about it at this one-hour cabaret produced by Michael Atwell.`,
      content: `
        <p>Cash Bar Available</p>
        <p>If you would like to dine at Rocco's Ristorante before or after Scandalous Stones, please call the restaurant at 304.453.3000 to reserve.  Ask for Joan or Harriet.</p>
      `,
      backgroundColor: "#1C6EFF",
      previewTemplate: ShowPreview,
      template: Show,
      sponsors: [
      ]
    },    
    {
      title: "A Doll's House",
      subtitle: "A production of the MU School of Theatre and Dance",
      date: new Date(2024, 9, 19),
      dateFormatted: "Saturday October 19th, 2024",
      dateFormattedShort: "Oct 19th",
      timeFormatted: "7:30 pm",
      location: "Francis-Booth Experimental Theatre (Inside Joan C. Edwards Playhouse)",
      ticketInfo: "For tickets call 304-696-ARTS",
      website: "",
      trailer: "",
      description: `This epochal drama of marriage and the individual portrays a controlling husband, Torvald Helmer, and his wife, Nora, a submissive young woman who, when their idealized homelife collapses, comes to the realization that she must finally close the door on her husband, children, and life in a “a doll’s house” to find and live as her true self.  Considered to be one of the great plays of the theatrical canon, A Doll’s House is as impactful today as it was in 1879.`,
      content: `
        <p>Post show talkback and meet & greet with actor Mark Povinelli.</p>
        <p>Star of stage and screen, Mark Povinelli has toured in the critically-acclaimed and OBIE award-winning Mabou Mines production of A Doll's House.</p>
      `,
      backgroundColor: "#1C6EFF",
      previewTemplate: ShowPreview,
      template: Show,
      sponsors: [
      ]
    },      
    {
      title: "The SpongeBob Musical",
      subtitle: "A production of the MU School of Theatre and Dance",
      date: new Date(2025, 3, 23),
      dateFormatted: "Wednesday April 23rd, 2025",
      dateFormattedShort: "Apr 23rd",
      timeFormatted: "7:30 pm",
      location: "Joan C. Edwards Playhouse",
      ticketInfo: "For tickets call 304-696-ARTS",
      website: "",
      trailer: "",
      description: `Plunge into this stunning all-singing, all-dancing, dynamic stage show!  When the citizens of Bikini Bottom discover that a volcano will soon erupt and destroy their humble home, SpongeBob and his friends must come together to save the fate of their undersea world.  With lives hanging in the balance and all hope lost, a most unexpected hero rises up.  The power of optimism really can save the world!`,
      content: `
        <p>An exiting new musical featuring irresistible characters and magical music, this deep-sea pearl of a show is set to make a splash with audiences young and old.  The future is bright, the future is bold, the future is The SpongeBob Musical.</p>
        <p>The SpongeBob Musical is based on the beloved animated series with original songs by:  Yolanda Adams, Steven Tyler and Joe Perry of Aerosmith, Sara Bareilles, The Flaming Lipsps, Lad A, Cyndi Lauper, John Legend, Panic! At the Disco, Plain White T’s, They Might Be Giants and T.I., and songs by David Bowie, Tom Kenny, and Andy Haley.</p>
      `,
      backgroundColor: "#1C6EFF",
      previewTemplate: ShowPreview,
      template: Show,
      sponsors: [
        {name:"Hoops Children's Hospital", level:1},
        {name:"Dr. Mark Studeny & Dr. Melissa Lester", level:2, text:true},
        {name:"Sammons Adams Orthodontics", level:2}
      ]
    },    
]

for (let show of shows) {
    if (!show.name)
        show.name = show.title.toLowerCase().replace(/\ /g, "_").replace(/\'/g, "").replace(/\!/g, "").replace(/\:/g, "").replace(/\./g, "");

    show.url = "/shows/" + show.name;

    //if (!show.festival || show.poster)
    if (!show.poster) {
      show.poster = process.env.PUBLIC_URL + "/shows/" + show.name + "/poster3.jpg?v7";
    }

    if (show.photos)
      show.photos = show.photos.map(p => process.env.PUBLIC_URL + "/shows/" + show.name + "/" + p + ".jpg?v7");

    if (show.tickets && show.tickets.length == 0)
        show.tickets = null;

    if (show.download && show.download.length > 0)
        show.download = process.env.PUBLIC_URL + "/shows/" + show.name + "/" + show.download;      

    if (show.festival && show.shows) {
        for (let festivalShow of show.shows) {
            festivalShow.name = festivalShow.title.toLowerCase().replace(/\ /g, "_");
            festivalShow.poster = process.env.PUBLIC_URL + "/shows/" + show.name + "/" + festivalShow.name.replace(/\'/g, "").replace(/\:/g, "") + ".jpg?v7";
            
            if (show.schedule) {
              festivalShow.schedule = [];

              for (const day in show.schedule) {
                const daySchedule = show.schedule[day];

                for (const time in daySchedule) {
                  if (daySchedule[time] == festivalShow.title) {
                    festivalShow.schedule.push(day + " - " + time);
                  }
                }
              }
            }
        }
    }

    if (show.trailer && show.trailer.length > 0 && show.trailer.indexOf("v=") != -1) {
      let videoId = show.trailer.split('v=')[1];
      let ampersandPosition = videoId.indexOf('&');

      if(ampersandPosition != -1) {
        videoId = videoId.substring(0, ampersandPosition);
      }     

      show.youtubeVideoId = videoId;
    }
}

let sortedShows = shows.slice();

sortedShows.sort(function(a,b){
    return a.date - b.date;
});

export function getAllShows() {
    return sortedShows;
}

export function getShowByName(name) {
    return shows.find(s => s.name == name);
}
